export default "__VITE_ASSET__ByEanEHv__"